module.exports = __webpack_public_path__ + "static/memsource-region-8792bdf5f58c9270553177ca359b10fb.jpg";